import { FC, useMemo, useState } from 'react';

import { Modal, List,  Input, Button } from 'antd';
import { Link } from 'react-router-dom';

import { getLinkPath } from '../../../../../helpers/utils/functions';
import { routeNames } from '../../../constants/routes';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

type ModalProps = {
	visible: boolean;
	onClose: () => void;
	schoolList: { [key: string]: string };
	selectedSchool: { id: string; name: string } | null;
	changeSchool: (id: string) => void;
};

const SchoolModal: FC<ModalProps> = ({ visible, onClose, schoolList, selectedSchool, changeSchool }) => {
	const ownedSchool = useTypedSelector((state) => state.currentUser.ownedSchool);
	const [ activeTab, setActiveTab ] = useState('all');
	const [ searchTerm, setSearchTerm ] = useState('');

	const currentSchool = useMemo(() => {
		switch(activeTab){
			case 'owner':
				return Object.entries(schoolList || {}).filter(([ key, ]) => {
					return ownedSchool.includes(Number(key));
				});
			case 'employee':
				return Object.entries(schoolList || {}).filter(([ key, ]) => {
					return !ownedSchool.includes(Number(key));
				});
			default:
				return Object.entries(schoolList || {});
		}
	}, [ activeTab ]);
	const filteredSchools = currentSchool.filter(([ , val ]) => {
		return val.toLowerCase().includes(searchTerm.toLowerCase());
	}
	);
	return (
	
		<Modal
			title={
				<div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
					<div style={{ display: 'flex', gap: 8, marginRight: 15 }}>
						<Button
							type={activeTab === 'all' ? 'primary' : 'default'}
							onClick={() => setActiveTab('all')}
							style={{ borderRadius: '5px' }}
						>
							Все
						</Button>
						<Button
							type={activeTab === 'owner' ? 'primary' : 'default'}
							onClick={() => setActiveTab('owner')}
							style={{ borderRadius: '5px' }}
						>
							Я владелец
						</Button>
						<Button
							type={activeTab === 'employee' ? 'primary' : 'default'}
							onClick={() => setActiveTab('employee')}
							style={{ borderRadius: '5px' }}
						>
							Я сотрудник
						</Button>
					</div>
					<Button
						type="primary"
						style={{ borderRadius: '5px' }}
						data-help-id="school-add"
					>
						<Link to={getLinkPath(routeNames.schoolAdd)}>
							Добавить школу
						</Link>
					</Button>
				</div>
			}
			open={visible}
			onCancel={onClose}
			onOk={onClose}
			footer={null}
			getContainer={() => document.body}
			style={{ position: 'absolute', top: '55px', left: '215px', transform: 'translateX(0)' }}
		>
			<Input
				placeholder="Поиск по названию школы"
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
				style={{ marginBottom: '10px', borderRadius: '5px' }}
			/>
			<div style={{ height: 400, overflow: 'scroll' }}>
			<List
				dataSource={filteredSchools}
				renderItem={([ key, val ]) => (
					<List.Item
						onClick={() => {
							changeSchool(key);
							onClose();
						}}
						style={{
							cursor: 'pointer',
							padding: '10px',
							backgroundColor: selectedSchool?.id === key ? '#f0f0f0' : 'white'
						}}
					>
						{val}
					</List.Item>
				)}
			/>
			</div>
		</Modal>
	);
};

export default SchoolModal;